<template>
  <v-dialog
      v-model="dialog"
      max-width="380"
      persistent
  >
    <v-card>
      <v-card-title class="headline">{{ title }}</v-card-title>
      <v-card-text v-html="text" class="pb-2">
      </v-card-text>
      <v-card-actions>
        <v-btn
            color="warning darken-1"
            text
            @click="disagree"
        >
          {{ disagreeButton }}
        </v-btn>
        <v-spacer/>
        <v-btn
            color="primary darken-1"
            text
            @click="agree"
        >
          {{ agreeButton }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmationDialog',
  props: ['title', 'agreeButton', 'disagreeButton'],
  data() {
    return {
      dialog: false,
      instanceId: null,
      text: '',
    }
  },
  methods: {
    showDialog(instanceId, text) {
      this.instanceId = instanceId;
      this.text = text;
      this.dialog = true;
    },
    agree() {
      this.dialog = false;
      this.$emit('agree', this.instanceId);
    },
    disagree() {
      this.dialog = false;
    },
  },
}
</script>

<style>
.highlighted {
  background-color: #d5e9d4;
  padding: .1rem .4rem;
  border-radius: 5px;
  color: #282828;
  white-space: nowrap;
}
</style>